/* globals PLUG, Flickity */

(function () {

    const U = PLUG.import("Utils");

    const defaultOptions = {
        cellAlign: "left",
        wrapAround: false,
        pageDots: false,
        contain: true,
        groupCells: "100%",
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 65, y2: 45,
          x3: 20
        }
    };

    class PlugProductSlider extends HTMLElement {
        constructor(options = {}) {
            super();

            this.options = Object.assign(defaultOptions, options);
            this.slider = {};
            this.isMobile = (window.innerWidth < 750);
            this.resizeListenerSetup = false;
            this.initialized = false;

            if (this.dataset.deferInit !== "true") {
                this.initSlider();
            } else {
                const initWhenVisible = (entries, observer) => {
                    if (!entries[0].isIntersecting) return;
                    observer.unobserve(this);
                    this.initSlider();
                };
                new IntersectionObserver(
                    initWhenVisible.bind(this),
                    { rootMargin: "0px 0px 200px 0px" }
                ).observe(this);
            }
        }

        initSlider() {
            const sliderEle = this.querySelector(".plug-product-slider__slides");

            if (this.createSlides) {
                this.initialized = true;
                const createSlidesFcn = this.createSlides;
                this.createSlides = undefined;
                return createSlidesFcn((docFrag, reason) => {
                    if (reason) throw reason;
                    sliderEle.appendChild(docFrag);
                    U.afterNextRepaint(() => {
                        this.initSlider();
                    });
                });
            } else if (!this.initialized && this.dataset.deferInit === "true") {
                this.waitingForSlideCreationFunction = true;
                return;
            }

            this.slider = new Flickity(sliderEle, this.options);
            U.afterNextRepaint(() => this.normalizeTitleHeights());
            this.setupSliderDots();

            if (!this.resizeListenerSetup) {
                this.resizeListenerSetup = true;
                let resizeTimer;
                window.addEventListener("resize", () => {
                    clearTimeout(resizeTimer);
                    resizeTimer = setTimeout(() => {
                        const wasMobile = this.isMobile;
                        this.isMobile = (window.innerWidth < 750);
                        if (
                            this.isMobile && !wasMobile
                            || !this.isMobile && wasMobile
                        ) {
                            this.rebuild();
                        }
                        this.normalizeTitleHeights();
                    }, 500);
                });
            }
        }

        setupSliderDots() {
            const numSlides = this.slider.slides.length;
            if (numSlides > 1) {

                const ul = document.createElement("ul");
                ul.className = "plug-slider-dots";
                let k = 0;
                while (k < numSlides) {
                    const li = document.createElement("li");
                    li.className = "plug-slider-dot" + (k === 0 ? " is-selected" : "");
                    li.dataset.index = k;
                    const button = document.createElement("button");
                    const span = document.createElement("span");
                    button.className = "plug-slider-dot-btn";
                    span.className = "plug-slider-dot-btn-inner";
                    button.appendChild(span);
                    li.appendChild(button);
                    ul.appendChild(li);
                    k += 1;
                }
                this.appendChild(ul);
            } else {
                const prevNextButtons = this.parentElement.querySelectorAll(".flickity-prev-next-button");
                prevNextButtons.forEach(btn => btn.classList.add("is-hidden"));
            }

            U.afterNextRepaint(() => {
                const dots = this.querySelectorAll(".plug-slider-dot");

                if (dots) {
                    dots.forEach((dot) => {
                        const index = Number(dot.dataset.index);
                        const button = dot.getElementsByTagName("button")[0];
                        button.addEventListener("click", () => {
                            this.slider.select(index);
                            U.removeClasses(dots, "is-selected");
                            dot.classList.add("is-selected");
                        });
                    });

                    this.slider.on("change", (index) => {
                        U.removeClasses(dots, "is-selected");
                        dots[index].classList.add("is-selected");
                    });
                }
            });
        }

        addSlideCreationFunction(fcn) {
            this.createSlides = fcn;
            if (this.waitingForSlideCreationFunction) {
                this.initSlider();
            }
        }

        rebuild() {
            this.slider.destroy();
            const dots = this.querySelector(".plug-slider-dots");
            if (dots) {
                dots.parentElement.removeChild(dots);
            }
            setTimeout(() => {
                this.initSlider();
            }, 300);
        }

        normalizeTitleHeights() {
            const titles = this.querySelectorAll(".plug-product-card__title");
            titles.forEach((title) => {
                const span = document.createElement("span");
                const titleText = title.textContent;
                title.appendChild(span);
                span.textContent = titleText;
                span.className = "temp-span";
            });
            U.afterNextRepaint(() => {
                let greatestHeightPx = 0;
                titles.forEach((title) => {
                    const span = title.querySelector(".temp-span");
                    if (span.offsetHeight > greatestHeightPx) {
                        greatestHeightPx = span.offsetHeight;
                    }
                });
                titles.forEach((title) => {
                    title.style.minHeight = greatestHeightPx + "px";
                    title.removeChild(title.querySelector(".temp-span"));
                });
            });
        }
    }

    customElements.define("plug-product-slider", PlugProductSlider);

})();
